import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { TaxGuide } from '@/pages/TaxGuide';
import { NotFoundComponent } from '@/ui/templates/NotFound/NotFoundComponent';

export const Route = createFileRoute('/shareworks/')({
  loader: ({ params }) => {
    console.log(params);
  },
  component: () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { id, ad } = Route.useSearch();
    if (!id) return <NotFoundComponent />;

    return (
      <TaxGuide userId={id} templateType={'shareworks'} ad={ad ? 1 : null} />
    );
  },
});
